// Traditional housekeeping quotes with a gentle, encouraging tone
export const quotes = [
  {
    text: "A tidy home is built one small act at a time.",
    author: "Traditional Wisdom"
  },
  {
    text: "The rhythm of the home is its own kind of music.",
    author: "The Gentle Homekeeper"
  },
  {
    text: "Rest is not laziness; it is preparation for the work ahead.",
    author: "Old Proverb"
  },
  {
    text: "A mother's love shows in the small, unseen moments.",
    author: "Traditional Wisdom"
  },
  {
    text: "The home is made by what we give, not what we perfect.",
    author: "The Calm Keeper"
  },
  {
    text: "Even the busiest bee returns to rest in the hive.",
    author: "Nature's Teaching"
  },
  {
    text: "A house becomes a home through presence, not perfection.",
    author: "Grandmother's Saying"
  },
  {
    text: "The seasons teach us that rest follows every harvest.",
    author: "Old Farm Wisdom"
  },
  {
    text: "Grace is found in knowing when enough is enough.",
    author: "The Gentle Way"
  },
  {
    text: "Your hands have done more today than you can count.",
    author: "A Mother's Truth"
  },
  {
    text: "The hearth is warm not from the fire alone, but from the hearts within.",
    author: "Cottage Wisdom"
  },
  {
    text: "Tomorrow's strength is built on tonight's rest.",
    author: "Traditional Proverb"
  },
  {
    text: "A gentle word to yourself is never wasted.",
    author: "The Kind Keeper"
  },
  {
    text: "The best meal is made with whatever is at hand.",
    author: "Kitchen Wisdom"
  },
  {
    text: "Peace in the home begins with peace in the heart.",
    author: "Quiet Teaching"
  },
  {
    text: "Your children remember your presence, not your productivity.",
    author: "A Mother's Legacy"
  },
  {
    text: "The dust will wait. Your soul cannot.",
    author: "Gentle Reminder"
  },
  {
    text: "Every day carries its own fullness.",
    author: "Morning Blessing"
  },
  {
    text: "You are the keeper of countless invisible things.",
    author: "Honoring the Unseen"
  },
  {
    text: "What matters most often makes no noise at all.",
    author: "Silent Truth"
  }
];

export const getQuoteOfTheDay = (index) => {
  return quotes[index % quotes.length];
};

export const getRandomQuote = () => {
  return quotes[Math.floor(Math.random() * quotes.length)];
};
